!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.TableauUI = t(require("react")) : e.TableauUI = t(e.React);
}("undefined" != typeof self ? self : this, function (e) {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/dist/", t(t.s = 13);
  }([function (e, t, r) {
    "use strict";

    function n(e, t) {
      function r() {
        this.constructor = e;
      }

      _2(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
    }

    function o(e, t) {
      var r = {};

      for (var n in e) {
        Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
      }

      if (null != e && "function" == typeof Object.getOwnPropertySymbols) for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++) {
        t.indexOf(n[o]) < 0 && (r[n[o]] = e[n[o]]);
      }
      return r;
    }

    function i(e, t, r, n) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, r, a) : o(t, r)) || a);
      }
      return i > 3 && a && Object.defineProperty(t, r, a), a;
    }

    function a(e, t) {
      return function (r, n) {
        t(r, n, e);
      };
    }

    function s(e, t) {
      if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
    }

    function l(e, t, r, n) {
      return new (r || (r = Promise))(function (o, i) {
        function a(e) {
          try {
            l(n.next(e));
          } catch (e) {
            i(e);
          }
        }

        function s(e) {
          try {
            l(n.throw(e));
          } catch (e) {
            i(e);
          }
        }

        function l(e) {
          e.done ? o(e.value) : new r(function (t) {
            t(e.value);
          }).then(a, s);
        }

        l((n = n.apply(e, t || [])).next());
      });
    }

    function c(e, t) {
      function r(e) {
        return function (t) {
          return n([e, t]);
        };
      }

      function n(r) {
        if (o) throw new TypeError("Generator is already executing.");

        for (; l;) {
          try {
            if (o = 1, i && (a = 2 & r[0] ? i.return : r[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, r[1])).done) return a;

            switch (i = 0, a && (r = [2 & r[0], a.value]), r[0]) {
              case 0:
              case 1:
                a = r;
                break;

              case 4:
                return l.label++, {
                  value: r[1],
                  done: !1
                };

              case 5:
                l.label++, i = r[1], r = [0];
                continue;

              case 7:
                r = l.ops.pop(), l.trys.pop();
                continue;

              default:
                if (a = l.trys, !(a = a.length > 0 && a[a.length - 1]) && (6 === r[0] || 2 === r[0])) {
                  l = 0;
                  continue;
                }

                if (3 === r[0] && (!a || r[1] > a[0] && r[1] < a[3])) {
                  l.label = r[1];
                  break;
                }

                if (6 === r[0] && l.label < a[1]) {
                  l.label = a[1], a = r;
                  break;
                }

                if (a && l.label < a[2]) {
                  l.label = a[2], l.ops.push(r);
                  break;
                }

                a[2] && l.ops.pop(), l.trys.pop();
                continue;
            }

            r = t.call(e, l);
          } catch (e) {
            r = [6, e], i = 0;
          } finally {
            o = a = 0;
          }
        }

        if (5 & r[0]) throw r[1];
        return {
          value: r[0] ? r[1] : void 0,
          done: !0
        };
      }

      var o,
          i,
          a,
          s,
          l = {
        label: 0,
        sent: function sent() {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: []
      };
      return s = {
        next: r(0),
        throw: r(1),
        return: r(2)
      }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
        return this;
      }), s;
    }

    function u(e, t) {
      for (var r in e) {
        t.hasOwnProperty(r) || (t[r] = e[r]);
      }
    }

    function d(e) {
      var t = "function" == typeof Symbol && e[Symbol.iterator],
          r = 0;
      return t ? t.call(e) : {
        next: function next() {
          return e && r >= e.length && (e = void 0), {
            value: e && e[r++],
            done: !e
          };
        }
      };
    }

    function p(e, t) {
      var r = "function" == typeof Symbol && e[Symbol.iterator];
      if (!r) return e;
      var n,
          o,
          i = r.call(e),
          a = [];

      try {
        for (; (void 0 === t || t-- > 0) && !(n = i.next()).done;) {
          a.push(n.value);
        }
      } catch (e) {
        o = {
          error: e
        };
      } finally {
        try {
          n && !n.done && (r = i.return) && r.call(i);
        } finally {
          if (o) throw o.error;
        }
      }

      return a;
    }

    function h() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e = e.concat(p(arguments[t]));
      }

      return e;
    }

    function f(e) {
      return this instanceof f ? (this.v = e, this) : new f(e);
    }

    function g(e, t, r) {
      function n(e) {
        u[e] && (c[e] = function (t) {
          return new Promise(function (r, n) {
            d.push([e, t, r, n]) > 1 || o(e, t);
          });
        });
      }

      function o(e, t) {
        try {
          i(u[e](t));
        } catch (e) {
          l(d[0][3], e);
        }
      }

      function i(e) {
        e.value instanceof f ? Promise.resolve(e.value.v).then(a, s) : l(d[0][2], e);
      }

      function a(e) {
        o("next", e);
      }

      function s(e) {
        o("throw", e);
      }

      function l(e, t) {
        e(t), d.shift(), d.length && o(d[0][0], d[0][1]);
      }

      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var c,
          u = r.apply(e, t || []),
          d = [];
      return c = {}, n("next"), n("throw"), n("return"), c[Symbol.asyncIterator] = function () {
        return this;
      }, c;
    }

    function y(e) {
      function t(t, o) {
        r[t] = e[t] ? function (r) {
          return (n = !n) ? {
            value: f(e[t](r)),
            done: "return" === t
          } : o ? o(r) : r;
        } : o;
      }

      var r, n;
      return r = {}, t("next"), t("throw", function (e) {
        throw e;
      }), t("return"), r[Symbol.iterator] = function () {
        return this;
      }, r;
    }

    function b(e) {
      function t(t) {
        n[t] = e[t] && function (n) {
          return new Promise(function (o, i) {
            n = e[t](n), r(o, i, n.done, n.value);
          });
        };
      }

      function r(e, t, r, n) {
        Promise.resolve(n).then(function (t) {
          e({
            value: t,
            done: r
          });
        }, t);
      }

      if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
      var n,
          o = e[Symbol.asyncIterator];
      return o ? o.call(e) : (e = "function" == typeof d ? d(e) : e[Symbol.iterator](), n = {}, t("next"), t("throw"), t("return"), n[Symbol.asyncIterator] = function () {
        return this;
      }, n);
    }

    function v(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    }

    function m(e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    }

    function w(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.__extends = n, r.d(t, "__assign", function () {
      return _S;
    }), t.__rest = o, t.__decorate = i, t.__param = a, t.__metadata = s, t.__awaiter = l, t.__generator = c, t.__exportStar = u, t.__values = d, t.__read = p, t.__spread = h, t.__await = f, t.__asyncGenerator = g, t.__asyncDelegator = y, t.__asyncValues = b, t.__makeTemplateObject = v, t.__importStar = m, t.__importDefault = w;
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var _2 = function _(e, t) {
      return (_2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) {
          t.hasOwnProperty(r) && (e[r] = t[r]);
        }
      })(e, t);
    },
        _S = function S() {
      return _S = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) {
          t = arguments[r];

          for (var o in t) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }

        return e;
      }, _S.apply(this, arguments);
    };
  }, function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      var t = new o.a({
        autoGenerateTag: !1
      });
      return e && t.setStylesTarget(e), t;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), r.d(t, "setStylesTarget", function () {
      return l;
    }), r.d(t, "cssRaw", function () {
      return c;
    }), r.d(t, "cssRule", function () {
      return u;
    }), r.d(t, "forceRenderStyles", function () {
      return d;
    }), r.d(t, "fontFace", function () {
      return p;
    }), r.d(t, "getStyles", function () {
      return h;
    }), r.d(t, "keyframes", function () {
      return f;
    }), r.d(t, "reinit", function () {
      return g;
    }), r.d(t, "style", function () {
      return y;
    }), r.d(t, "stylesheet", function () {
      return b;
    }), t.createTypeStyle = n;
    var o = r(15);
    r.d(t, "TypeStyle", function () {
      return o.a;
    });
    var i = r(18);
    r.n(i);
    r.d(t, "types", function () {
      return i;
    });
    var a = r(7);
    r.d(t, "extend", function () {
      return a.b;
    }), r.d(t, "classes", function () {
      return a.a;
    }), r.d(t, "media", function () {
      return a.c;
    });
    var s = new o.a({
      autoGenerateTag: !0
    }),
        l = s.setStylesTarget,
        c = s.cssRaw,
        u = s.cssRule,
        d = s.forceRenderStyles,
        p = s.fontFace,
        h = s.getStyles,
        f = s.keyframes,
        g = s.reinit,
        y = s.style,
        b = s.stylesheet;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(0),
        o = ["#000000", "#1B1B1B", "#333333", "#555555", "#666666", "#898989", "#FFFFFF", "#F5F5F5", "#E6E6E6", "#D4D4D4", "#C0C0C0", "#B4B4B4"],
        i = ["#F28E2B", "#F9A655", "#FFBE7D", "#B07AA1", "#C290B4", "#D4A6C8", "#B6992D", "#D3B348", "#F1CE63", "#D37295", "#E799B3", "#FABFD2", "#59A14F", "#72B966", "#8CD17D", "#E15759", "#F17B79", "#FF9D9A", "#499894", "#69AAA5", "#86BCB6", "#9D7660", "#BA9582", "#D7B5A6", "#4E79A7", "#75A1C7", "#A0CBE8", "#79706E", "#998F8C", "#BAB0AC", "#606B76", "#818B91", "#A7ACAD", "#76B7B2", "#FF9DA7", "#EDC948"],
        a = ["#EFEBE8", "#F5F1F0", "#F9F8F7", "#F0EAE8", "#F5F0EF", "#FAF5F4", "#F5EDDC", "#FAF4E7", "#FEFAF1", "#E9EBE0", "#F0F1E8", "#F7F7F0", "#EBEBEB", "#F2F2F2", "#F9F9F9", "#DFE7E8", "#E9F0F1", "#F2F9F9", "#F3EBF3", "#F7F1F6", "#FBF7FB", "#E2E6F0", "#E9EDF5", "#F0F3FA", "#E6ECF0", "#EEF1F3", "#F2F6F7", "#DDEBF0", "#E7F1F5", "#F0F7FA", "#DFEDEB", "#E9F3F2", "#F3FAF9", "#E8EDDA", "#EFF3E3", "#F7FAF0", "#F5EAD7", "#F6EEE3", "#FAF5F0", "#F9E9E0", "#F9EEE8", "#F9F3EF"],
        s = ["#4F6980", "#3D7FA6", "#8BC2CA", "#499893", "#62AEA1", "#7DC4AE", "#638B66", "#86AF6A", "#C3BB3D", "#EFC637", "#F6A035", "#F37941", "#F59A9A", "#CD677F", "#C497B7", "#845578", "#B9AA98", "#7E756D", "#9EB0A5", "#B56252"],
        l = {
      XXLarge: 24,
      XLarge: 18,
      Large: 13,
      Default: 12,
      Small: 11,
      Tiny: 10
    },
        c = {
      PrimaryDark: "rgba(0, 0, 0, 0.9)",
      Primary: "rgba(0, 0, 0, 0.8)",
      PrimaryMedium: "rgba(0, 0, 0, 0.7)",
      PrimaryLight: "rgba(0, 0, 0, 0.6)",
      Secondary: "rgba(0, 0, 0, 0.56)",
      Disabled: "rgba(0, 0, 0, 0.35)",
      InvertedPrimary: "rgba(255, 255, 255, 1)",
      InvertedSecondary: "rgba(255, 255, 255, .56)",
      InvertedDisabled: "rgba(255, 255, 255, .35)"
    },
        u = {
      Grey250: "rgb(250, 250, 250)",
      Grey245: "rgb(245, 245, 245)",
      Grey235: "rgb(235, 235, 235)",
      Grey230: "rgb(230, 230, 230)",
      Grey225: "rgb(225, 225, 225)",
      Grey212: "rgb(212, 212, 212)",
      Grey203: "rgb(203, 203, 203)",
      Grey180: "rgb(180, 180, 180)",
      Grey180Disabled: "rgba(180, 180, 180, 0.35)",
      Grey102: "rgb(102, 102, 102)",
      Grey51: "rgb(51, 51, 51)",
      Grey51Disabled: "rgba(51, 51, 51, 0.2)"
    },
        d = {
      White: "rgb(255, 255, 255)",
      WhiteTransparent: "rgba(255, 255, 255, 0.25)",
      WhiteDisabled: "rgba(255, 255, 255, 0.35)",
      WhiteTransparentLine: "rgba(255, 255, 255, 0.5)",
      WhiteTransparentLineHover: "rgba(255, 255, 255, 0.8)",
      Black: "rgb(0, 0, 0)",
      Transparent: "rgba(0, 0, 0, 0)",
      ActionLight: "rgb(235, 143, 80)",
      ActionDark: "rgb(209, 107, 54)",
      AttentionLight: "rgb(235, 68, 84)",
      AttentionDark: "rgb(201, 58, 71)",
      AttentionDarkDisabled: "rgba(201, 58, 71, 0.35)",
      Continuous: "rgb(0, 177, 128)",
      ContinuousDark: "rgb(0, 151, 104)",
      Discrete: "rgb(73, 150, 178)",
      DiscreteDark: "rgb(54, 126,156)",
      GoLight: "rgb(45, 204, 151)",
      GoDark: "rgb(47, 163, 125)",
      GoDarkDisabled: "rgba(47, 163, 125, 0.35)",
      Shaded: "rgba(0, 0, 0, 0.07)",
      ApplicationBlue: "rgb(34, 38, 54)",
      DesktopBlue: "rgb(53, 92, 128)",
      ServerBlue: "rgb(42, 87, 117)",
      OnlineBlue: "rgb(40, 94, 127)",
      OpaqueGlass: u.Grey245,
      Focus: "rgb(52, 152, 219)",
      L1: u.Grey250,
      L2: u.Grey245,
      L2_5: u.Grey235,
      L3: u.Grey230,
      L4: u.Grey225,
      L5: u.Grey212,
      L6: u.Grey203,
      L7: u.Grey180,
      L8: u.Grey102,
      L9: u.Grey51,
      L9Disabled: u.Grey51Disabled,
      F1: u.Grey250,
      F2: u.Grey245,
      F2_5: u.Grey235,
      F3: u.Grey230,
      F4: u.Grey225,
      F5: u.Grey212,
      F6: u.Grey203,
      F7: u.Grey180,
      F7Disabled: u.Grey180Disabled,
      F8: u.Grey102,
      F9: u.Grey51
    },
        p = {
      Colors: d,
      Shadow: {
        Standard: "1px 1px 2px 0px rgba(0, 0, 0, 0.15)"
      },
      Spacing: {
        SmallSpace: 3,
        DefaultSpace: 6,
        MediumSpace: 12,
        LargeSpace: 18,
        ExtraLargeSpace: 24
      },
      Sizing: {
        BaseUnit: 6,
        RowHeight: 24,
        ButtonMinWidth: 90,
        BorderWidth: 1,
        ButtonBorderWidth: 2,
        BorderRadius: 1,
        SelectionBorderWidth: 3,
        ListRowHeight: 20
      },
      Typography: {
        FontFamily: "Benton Sans, Arial, Helvetica, sans-serif",
        Sizing: l,
        Color: c
      },
      Opacity: {
        ClearGlass: .01,
        Disabled: .35,
        OpaqueGlass: .33
      },
      ColorPickerPresets: {
        Dark: o.concat(i),
        Light: o.concat(a),
        MaestroFlowColors: s
      }
    };
    t.TabStyles = p;

    var h = function h(e) {
      p.Colors = n.__assign({}, p.Colors, e.Colors), p.Opacity = n.__assign({}, p.Opacity, e.Opacity), p.Shadow = n.__assign({}, p.Shadow, e.Shadow), p.Sizing = n.__assign({}, p.Sizing, e.Sizing), p.Spacing = n.__assign({}, p.Spacing, e.Spacing), e.Typography && (p.Typography.FontFamily = e.Typography.FontFamily ? e.Typography.FontFamily : p.Typography.FontFamily, p.Typography.Color = n.__assign({}, p.Typography.Color, e.Typography.Color), p.Typography.Sizing = n.__assign({}, p.Typography.Sizing, e.Typography.Sizing));
    };

    t.overrideTabStyles = h;
  }, function (e, t, r) {
    "use strict";

    function n() {
      return "tableau-ui-" + a++;
    }

    function o(e) {
      return e && e.clientWidth < e.scrollWidth;
    }

    function i(e, t) {
      if (e.closest) return e.closest(t);
      var r = Element.prototype.matches || Element.prototype.msMatchesSelector;
      if (!r) return null;

      for (var n = e; n;) {
        if (r.call(n, t)) return n;
        n = n.parentElement;
      }

      return null;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = Date.now();
    t.generateId = n, t.isElementOverflownX = o, t.closest = i;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.PreventUserSelect = {
      userSelect: "none",
      WebkitUserSelect: "none",
      msUserSelect: "none",
      MozUserSelect: "none",
      cursor: "default"
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      function r(e) {
        return e.replace(g, m).replace(y, "-ms-");
      }

      function n(e) {
        for (var t = 5381, r = e.length; r--;) {
          t = 33 * t ^ e.charCodeAt(r);
        }

        return (t >>> 0).toString(36);
      }

      function o(e, t) {
        return "number" != typeof t || 0 === t || _[e] ? e + ":" + t : e + ":" + t + "px";
      }

      function i(e) {
        return e.sort(function (e, t) {
          return e[0] > t[0] ? 1 : -1;
        });
      }

      function a(e, n) {
        for (var o = [], a = [], l = !1, c = 0, u = Object.keys(e); c < u.length; c++) {
          var d = u[c],
              p = e[d];
          null !== p && void 0 !== p && (d === t.IS_UNIQUE ? l = !0 : "object" != typeof p || Array.isArray(p) ? o.push([r(d.trim()), p]) : a.push([d.trim(), p]));
        }

        return {
          styleString: s(i(o)),
          nestedStyles: n ? a : i(a),
          isUnique: l
        };
      }

      function s(e) {
        return e.map(function (e) {
          var t = e[0],
              r = e[1];
          return Array.isArray(r) ? r.map(function (e) {
            return o(t, e);
          }).join(";") : o(t, r);
        }).join(";");
      }

      function l(e, t) {
        return e.indexOf("&") > -1 ? e.replace(b, t) : t + " " + e;
      }

      function c(e, t, r, n, o) {
        var i = a(r, !!t),
            s = i.styleString,
            u = i.nestedStyles,
            d = i.isUnique,
            p = s;

        if (64 === t.charCodeAt(0)) {
          var h = e.add(new B(t, o ? void 0 : s, e.hash));

          if (s && o) {
            var g = h.add(new A(s, h.hash, d ? "u" + (++f).toString(36) : void 0));
            n.push([o, g]);
          }

          for (var y = 0, b = u; y < b.length; y++) {
            var v = b[y],
                m = v[0],
                w = v[1];
            p += m + c(h, m, w, n, o);
          }
        } else {
          var _ = o ? l(t, o) : t;

          if (s) {
            var g = e.add(new A(s, e.hash, d ? "u" + (++f).toString(36) : void 0));
            n.push([_, g]);
          }

          for (var S = 0, C = u; S < C.length; S++) {
            var x = C[S],
                m = x[0],
                w = x[1];
            p += m + c(e, m, w, n, _);
          }
        }

        return p;
      }

      function u(e, r, n, o, i) {
        for (var a = new E(e.hash), s = [], u = c(a, r, n, s), d = "f" + a.hash(u), p = i ? i + "_" + d : d, h = 0, f = s; h < f.length; h++) {
          var g = f[h],
              y = g[0],
              b = g[1],
              v = o ? l(y, "." + t.escape(p)) : y;
          b.add(new I(v, b.hash, void 0, u));
        }

        return {
          cache: a,
          pid: u,
          id: p
        };
      }

      function d(e) {
        for (var t = "", r = 0; r < e.length; r++) {
          t += e[r];
        }

        return t;
      }

      function p(e, t, r) {
        return new P(e, t, void 0, r);
      }

      var h = this && this.__extends || function () {
        var e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) {
            t.hasOwnProperty(r) && (e[r] = t[r]);
          }
        };

        return function (t, r) {
          function n() {
            this.constructor = t;
          }

          e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
        };
      }();

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var f = 0;
      t.IS_UNIQUE = "__DO_NOT_DEDUPE_STYLE__";

      for (var g = /[A-Z]/g, y = /^ms-/, b = /&/g, v = /[ !#$%&()*+,.\/;<=>?@[\]^`{|}~"'\\]/g, m = function m(e) {
        return "-" + e.toLowerCase();
      }, w = ["animation-iteration-count", "box-flex", "box-flex-group", "column-count", "counter-increment", "counter-reset", "flex", "flex-grow", "flex-positive", "flex-shrink", "flex-negative", "font-weight", "line-clamp", "line-height", "opacity", "order", "orphans", "tab-size", "widows", "z-index", "zoom", "fill-opacity", "stroke-dashoffset", "stroke-opacity", "stroke-width"], _ = Object.create(null), S = 0, C = ["-webkit-", "-ms-", "-moz-", "-o-", ""]; S < C.length; S++) {
        for (var x = C[S], F = 0, T = w; F < T.length; F++) {
          var k = T[F];
          _[x + k] = !0;
        }
      }

      t.escape = function (e) {
        return e.replace(v, "\\$&");
      }, t.hyphenate = r, t.stringHash = n;

      var D = {
        add: function add() {},
        change: function change() {},
        remove: function remove() {}
      },
          E = function () {
        function e(e, t) {
          void 0 === e && (e = n), void 0 === t && (t = D), this.hash = e, this.changes = t, this.sheet = [], this.changeId = 0, this._keys = [], this._children = Object.create(null), this._counters = Object.create(null);
        }

        return e.prototype.add = function (t) {
          var r = this._counters[t.id] || 0,
              n = this._children[t.id] || t.clone();
          if (this._counters[t.id] = r + 1, 0 === r) this._children[n.id] = n, this._keys.push(n.id), this.sheet.push(n.getStyles()), this.changeId++, this.changes.add(n, this._keys.length - 1);else {
            if (n.getIdentifier() !== t.getIdentifier()) throw new TypeError("Hash collision: " + t.getStyles() + " === " + n.getStyles());

            var o = this._keys.indexOf(t.id),
                i = this._keys.length - 1,
                a = this.changeId;

            if (o !== i && (this._keys.splice(o, 1), this._keys.push(t.id), this.changeId++), n instanceof e && t instanceof e) {
              var s = n.changeId;
              n.merge(t), n.changeId !== s && this.changeId++;
            }

            this.changeId !== a && (o === i ? this.sheet.splice(o, 1, n.getStyles()) : (this.sheet.splice(o, 1), this.sheet.splice(i, 0, n.getStyles())), this.changes.change(n, o, i));
          }
          return n;
        }, e.prototype.remove = function (t) {
          var r = this._counters[t.id];

          if (r > 0) {
            this._counters[t.id] = r - 1;

            var n = this._children[t.id],
                o = this._keys.indexOf(n.id);

            if (1 === r) delete this._counters[t.id], delete this._children[t.id], this._keys.splice(o, 1), this.sheet.splice(o, 1), this.changeId++, this.changes.remove(n, o);else if (n instanceof e && t instanceof e) {
              var i = n.changeId;
              n.unmerge(t), n.changeId !== i && (this.sheet.splice(o, 1, n.getStyles()), this.changeId++, this.changes.change(n, o, o));
            }
          }
        }, e.prototype.merge = function (e) {
          for (var t = 0, r = e._keys; t < r.length; t++) {
            var n = r[t];
            this.add(e._children[n]);
          }

          return this;
        }, e.prototype.unmerge = function (e) {
          for (var t = 0, r = e._keys; t < r.length; t++) {
            var n = r[t];
            this.remove(e._children[n]);
          }

          return this;
        }, e.prototype.clone = function () {
          return new e(this.hash).merge(this);
        }, e;
      }();

      t.Cache = E;

      var I = function () {
        function e(e, t, r, n) {
          void 0 === r && (r = "s" + t(e)), void 0 === n && (n = ""), this.selector = e, this.hash = t, this.id = r, this.pid = n;
        }

        return e.prototype.getStyles = function () {
          return this.selector;
        }, e.prototype.getIdentifier = function () {
          return this.pid + "." + this.selector;
        }, e.prototype.clone = function () {
          return new e(this.selector, this.hash, this.id, this.pid);
        }, e;
      }();

      t.Selector = I;

      var A = function (e) {
        function t(t, r, n) {
          void 0 === n && (n = "c" + r(t));
          var o = e.call(this, r) || this;
          return o.style = t, o.hash = r, o.id = n, o;
        }

        return h(t, e), t.prototype.getStyles = function () {
          return this.sheet.join(",") + "{" + this.style + "}";
        }, t.prototype.getIdentifier = function () {
          return this.style;
        }, t.prototype.clone = function () {
          return new t(this.style, this.hash, this.id).merge(this);
        }, t;
      }(E);

      t.Style = A;

      var B = function (e) {
        function t(t, r, n, o, i) {
          void 0 === r && (r = ""), void 0 === o && (o = "a" + n(t + "." + r)), void 0 === i && (i = "");
          var a = e.call(this, n) || this;
          return a.rule = t, a.style = r, a.hash = n, a.id = o, a.pid = i, a;
        }

        return h(t, e), t.prototype.getStyles = function () {
          return this.rule + "{" + this.style + d(this.sheet) + "}";
        }, t.prototype.getIdentifier = function () {
          return this.pid + "." + this.rule + "." + this.style;
        }, t.prototype.clone = function () {
          return new t(this.rule, this.style, this.hash, this.id, this.pid).merge(this);
        }, t;
      }(E);

      t.Rule = B;

      var P = function (r) {
        function o(t, o, i, a) {
          void 0 === t && (t = n), void 0 === o && (o = void 0 !== e && !1), void 0 === i && (i = "f" + (++f).toString(36));
          var s = r.call(this, t, a) || this;
          return s.hash = t, s.debug = o, s.id = i, s;
        }

        return h(o, r), o.prototype.registerStyle = function (e, t) {
          var r = this.debug ? t : void 0,
              n = u(this, "&", e, !0, r),
              o = n.cache,
              i = n.id;
          return this.merge(o), i;
        }, o.prototype.registerKeyframes = function (e, t) {
          return this.registerHashRule("@keyframes", e, t);
        }, o.prototype.registerHashRule = function (e, r, n) {
          var o = this.debug ? n : void 0,
              i = u(this, "", r, !1, o),
              a = i.cache,
              s = i.pid,
              l = i.id,
              c = new B(e + " " + t.escape(l), void 0, this.hash, void 0, s);
          return this.add(c.merge(a)), l;
        }, o.prototype.registerRule = function (e, t) {
          this.merge(u(this, e, t, !1).cache);
        }, o.prototype.registerCss = function (e) {
          this.merge(u(this, "", e, !1).cache);
        }, o.prototype.getStyles = function () {
          return d(this.sheet);
        }, o.prototype.getIdentifier = function () {
          return this.id;
        }, o.prototype.clone = function () {
          return new o(this.hash, this.debug, this.id, this.changes).merge(this);
        }, o;
      }(E);

      t.FreeStyle = P, t.create = p;
    }).call(t, r(16));
  }, function (e, t, r) {
    "use strict";

    function n() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      return e.filter(function (e) {
        return !!e;
      }).join(" ");
    }

    function o() {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      for (var r = {}, n = 0, i = e; n < i.length; n++) {
        var a = i[n];
        if (null != a && !1 !== a) for (var s in a) {
          var l = a[s];
          (l || 0 === l) && ("$nest" === s && l ? r[s] = r.$nest ? o(r.$nest, l) : l : -1 !== s.indexOf("&") || 0 === s.indexOf("@media") ? r[s] = r[s] ? o(r[s], l) : l : r[s] = l);
        }
      }

      return r;
    }

    r.d(t, "d", function () {
      return i;
    }), t.a = n, t.b = o, r.d(t, "c", function () {
      return a;
    });

    var i = "undefined" == typeof requestAnimationFrame ? function (e) {
      return setTimeout(e);
    } : "undefined" == typeof window ? requestAnimationFrame : requestAnimationFrame.bind(window),
        a = function a(e) {
      for (var t = [], r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }

      var n = [];
      e.type && n.push(e.type), e.orientation && n.push("(orientation: " + e.orientation + ")"), e.minWidth && n.push("(min-width: " + s(e.minWidth) + ")"), e.maxWidth && n.push("(max-width: " + s(e.maxWidth) + ")"), e.minHeight && n.push("(min-height: " + s(e.minHeight) + ")"), e.maxHeight && n.push("(max-height: " + s(e.maxHeight) + ")");
      var i = "@media " + n.join(" and ");
      return {
        $nest: (a = {}, a[i] = o.apply(void 0, t), a)
      };
      var a;
    },
        s = function s(e) {
      return "string" == typeof e ? e : e + "px";
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return !!e && Object.prototype.hasOwnProperty.call(e, "current");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = r(0),
        i = r(1),
        a = r(2),
        s = r(5),
        l = r(3),
        c = r(4),
        u = l.TabStyles.Colors,
        d = u.Focus,
        p = u.L8,
        h = u.L9,
        f = function f(e) {
      return void 0 === e && (e = p), "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16"><path fill="' + e + '" transform="translate(-2, -2)" d="M7.2 12.3c-.2 0-.4-.1-.5-.2l-3-3L4.8 8l2.3 2.3 4-6.7 1.3.8L7.9 12c-.2.2-.4.3-.7.3z"/></svg>') + "')";
    },
        g = function g(e) {
      return void 0 === e && (e = p), "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16"><rect fill="' + e + '" x="2" y="2" width="8" height="8"/></svg>') + "')";
    },
        y = function y(e) {
      return void 0 === e && (e = p), "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16"><circle fill="' + e + '" transform="translate(-2, -2)" cx="8" cy="8" r="3"/></svg>') + "')";
    },
        b = a.style({
      boxSizing: "border-box",
      flexShrink: 0,
      height: 14,
      margin: 0,
      marginTop: 3,
      opacity: 0,
      padding: 0,
      pointerEvents: "none",
      width: 14
    }),
        v = a.style(s.PreventUserSelect, {
      color: l.TabStyles.Typography.Color.Primary,
      fontFamily: l.TabStyles.Typography.FontFamily,
      fontSize: l.TabStyles.Typography.Sizing.Default,
      lineHeight: l.TabStyles.Sizing.ListRowHeight + "px",
      position: "relative",
      $nest: {
        "&:not(:empty)": {
          paddingLeft: 6
        },
        "&.disabled": {
          color: l.TabStyles.Typography.Color.Disabled
        },
        "&:before": {
          backgroundColor: "white",
          boxSizing: "border-box",
          borderRadius: 1,
          border: "1px solid " + p,
          content: "'\\200B'",
          display: "inline-block",
          height: 14,
          left: -14,
          position: "absolute",
          top: 3,
          width: 14
        },
        'input[type="radio"] + &:before': {
          borderRadius: "100%"
        },
        "&:hover:before": {
          borderColor: h
        },
        ":focus + &:before": {
          borderColor: d
        },
        ":active + &:before": {
          borderColor: h
        },
        'input[type="checkbox"] + &.checked:before': {
          content: f(p)
        },
        'input[type="checkbox"] + &:hover.checked:before': {
          content: f(h)
        },
        'input[type="checkbox"] + &.indeterminate:before': {
          content: g(p)
        },
        'input[type="checkbox"] + &:hover.indeterminate:before': {
          content: g(h)
        },
        'input[type="radio"] + &.checked:before': {
          content: y(p)
        },
        'input[type="radio"] + &:hover.checked:before': {
          content: y(h)
        },
        "&.disabled:before": {
          borderColor: h,
          opacity: l.TabStyles.Opacity.Disabled
        }
      }
    }),
        m = a.style({
      display: "inline-flex"
    });

    t.Selector = i.forwardRef(function (e, t) {
      var r = e.children,
          s = e.className,
          l = e.id,
          u = e.indeterminate,
          d = e.style,
          p = o.__rest(e, ["children", "className", "id", "indeterminate", "style"]),
          h = c.generateId(),
          f = function f(e) {
        n(t) ? t.current = e : t && t(e), e && (e.indeterminate = u);
      },
          g = a.classes(v, e.checked && "checked", e.disabled && "disabled", u && "indeterminate");

      return i.createElement("div", {
        className: a.classes(s, m),
        id: l,
        style: d
      }, i.createElement("input", o.__assign({}, p, {
        id: h,
        className: b,
        ref: f
      })), i.createElement("label", {
        htmlFor: h,
        className: g
      }, r));
    });
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return !!navigator && e.test(navigator.userAgent);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.isIE = n(/Trident/), t.isEdge = n(/Edge\//);
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      return e ? t : void 0;
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.conditional = n;
  }, function (e, t, r) {
    "use strict";

    function n(e, t, r) {
      return r < t ? NaN : Math.min(Math.max(e, t), r);
    }

    function o(e, t) {
      void 0 === t && (t = 1);
      var r = e / t;
      return Math.abs(Math.floor(r) - r) < s && (r = Math.floor(r)), Math.ceil(r) * t;
    }

    function i(e, t) {
      void 0 === t && (t = 1);
      var r = e / t;
      return Math.abs(Math.ceil(r) - r) < s && (r = Math.ceil(r)), Math.floor(r) * t;
    }

    function a(e) {
      return e > 0 ? Math.floor(e) : Math.ceil(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var s = 1e-11;
    t.clamp = n, t.snapUp = o, t.snapDown = i, t.truncate = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(2),
        o = r(5),
        i = r(3),
        a = r(31),
        s = i.TabStyles.Colors,
        l = i.TabStyles.Typography.Color,
        c = i.TabStyles.Spacing,
        u = c.ExtraLargeSpace;
    t.TabListClassName = n.style({
      backgroundColor: s.F2,
      display: "flex",
      fontFamily: i.TabStyles.Typography.FontFamily,
      fontSize: i.TabStyles.Typography.Sizing.Default,
      height: "42px"
    }, o.PreventUserSelect), t.TabButtonClassName = n.style({
      backgroundColor: s.F2,
      border: "none",
      display: "inline-block",
      height: "100%",
      overflow: "hidden",
      padding: 0,
      position: "relative",
      $nest: {
        '&[aria-selected="true"]': {
          fontWeight: "bold"
        },
        "&:hover > :last-child": {
          backgroundColor: s.L5
        },
        '&[aria-selected="true"] > :last-child': {
          backgroundColor: s.L8
        },
        "&:focus > :last-child": {
          backgroundColor: s.Focus
        },
        "&:active > :last-child": {
          backgroundColor: s.L9
        }
      }
    }), t.TabContentContainerClassName = n.style({
      alignItems: "center",
      color: l.PrimaryLight,
      display: "flex",
      height: "100%",
      justifyContent: "center",
      paddingLeft: u,
      paddingRight: u
    }, a.TextEllipsis), t.TabContentClassName = n.style({
      display: "block"
    }, a.TextEllipsis), t.TabIndicatorClassName = n.style({
      backgroundColor: "transparent",
      bottom: 0,
      height: 3,
      position: "absolute",
      width: "100%"
    }), t.TabPanelOuterContainerClassName = n.style({
      overflowY: "auto",
      padding: c.LargeSpace,
      position: "relative",
      "-webkit-overflow-scrolling": "touch"
    });
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(14);
    t.Button = n.Button;
    var o = r(20);
    t.Checkbox = o.Checkbox;
    var i = r(21);
    t.DropdownSelect = i.DropdownSelect;
    var a = r(23);
    t.Stepper = a.Stepper;
    var s = r(24);
    t.Pill = s.Pill;
    var l = r(26);
    t.Radio = l.Radio;
    var c = r(27);
    t.Spinner = c.Spinner;
    var u = r(29);
    t.Tabs = u.Tabs;
    var d = r(32);
    t.TextField = d.TextField;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(0),
        o = r(1),
        i = r(2),
        a = r(19);
    t.Button = o.forwardRef(function (e, t) {
      var r = e.className,
          s = e.kind,
          l = n.__rest(e, ["className", "kind"]);

      return o.createElement("button", n.__assign({}, l, {
        className: i.classes(a.ButtonClassNames[s], r),
        ref: t
      }));
    });
    t.Button.defaultProps = {
      kind: "outline"
    }, t.Button.displayName = "Button";
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return s;
    });

    var n = r(6),
        o = (r.n(n), r(17)),
        i = r(7),
        a = function a() {
      return n.create(void 0, !0);
    },
        s = function () {
      function e(e) {
        var t = e.autoGenerateTag,
            r = this;
        this.cssRaw = function (e) {
          e && (r._raw += e || "", r._pendingRawChange = !0, r._styleUpdated());
        }, this.cssRule = function (e) {
          for (var t = [], n = 1; n < arguments.length; n++) {
            t[n - 1] = arguments[n];
          }

          var a = Object(o.a)(i.b.apply(void 0, t)).result;
          r._freeStyle.registerRule(e, a), r._styleUpdated();
        }, this.forceRenderStyles = function () {
          var e = r._getTag();

          e && (e.textContent = r.getStyles());
        }, this.fontFace = function () {
          for (var e = [], t = 0; t < arguments.length; t++) {
            e[t] = arguments[t];
          }

          for (var n = r._freeStyle, o = 0, i = e; o < i.length; o++) {
            var a = i[o];
            n.registerRule("@font-face", a);
          }

          r._styleUpdated();
        }, this.getStyles = function () {
          return (r._raw || "") + r._freeStyle.getStyles();
        }, this.keyframes = function (e) {
          var t = Object(o.b)(e),
              n = t.keyframes,
              i = t.$debugName,
              a = r._freeStyle.registerKeyframes(n, i);

          return r._styleUpdated(), a;
        }, this.reinit = function () {
          var e = a();
          r._freeStyle = e, r._lastFreeStyleChangeId = e.changeId, r._raw = "", r._pendingRawChange = !1;

          var t = r._getTag();

          t && (t.textContent = "");
        }, this.setStylesTarget = function (e) {
          r._tag && (r._tag.textContent = ""), r._tag = e, r.forceRenderStyles();
        }, this.stylesheet = function (e) {
          for (var t = Object.getOwnPropertyNames(e), n = {}, o = 0, i = t; o < i.length; o++) {
            var a = i[o],
                s = e[a];
            s && (s.$debugName = a, n[a] = r.style(s));
          }

          return n;
        };
        var n = a();
        this._autoGenerateTag = t, this._freeStyle = n, this._lastFreeStyleChangeId = n.changeId, this._pending = 0, this._pendingRawChange = !1, this._raw = "", this._tag = void 0, this.style = this.style.bind(this);
      }

      return e.prototype._afterAllSync = function (e) {
        var t = this;
        this._pending++;
        var r = this._pending;
        Object(i.d)(function () {
          r === t._pending && e();
        });
      }, e.prototype._getTag = function () {
        if (this._tag) return this._tag;

        if (this._autoGenerateTag) {
          var e = "undefined" == typeof window ? {
            textContent: ""
          } : document.createElement("style");
          return "undefined" != typeof document && document.head.appendChild(e), this._tag = e, e;
        }
      }, e.prototype._styleUpdated = function () {
        var e = this,
            t = this._freeStyle.changeId,
            r = this._lastFreeStyleChangeId;
        (this._pendingRawChange || t !== r) && (this._lastFreeStyleChangeId = t, this._pendingRawChange = !1, this._afterAllSync(function () {
          return e.forceRenderStyles();
        }));
      }, e.prototype.style = function () {
        var e = this._freeStyle,
            t = Object(o.a)(i.b.apply(void 0, arguments)),
            r = t.result,
            n = t.debugName,
            a = n ? e.registerStyle(r, n) : e.registerStyle(r);
        return this._styleUpdated(), a;
      }, e;
    }();
  }, function (e, t) {
    function r() {
      throw new Error("setTimeout has not been defined");
    }

    function n() {
      throw new Error("clearTimeout has not been defined");
    }

    function o(e) {
      if (u === setTimeout) return setTimeout(e, 0);
      if ((u === r || !u) && setTimeout) return u = setTimeout, setTimeout(e, 0);

      try {
        return u(e, 0);
      } catch (t) {
        try {
          return u.call(null, e, 0);
        } catch (t) {
          return u.call(this, e, 0);
        }
      }
    }

    function i(e) {
      if (d === clearTimeout) return clearTimeout(e);
      if ((d === n || !d) && clearTimeout) return d = clearTimeout, clearTimeout(e);

      try {
        return d(e);
      } catch (t) {
        try {
          return d.call(null, e);
        } catch (t) {
          return d.call(this, e);
        }
      }
    }

    function a() {
      g && h && (g = !1, h.length ? f = h.concat(f) : y = -1, f.length && s());
    }

    function s() {
      if (!g) {
        var e = o(a);
        g = !0;

        for (var t = f.length; t;) {
          for (h = f, f = []; ++y < t;) {
            h && h[y].run();
          }

          y = -1, t = f.length;
        }

        h = null, g = !1, i(e);
      }
    }

    function l(e, t) {
      this.fun = e, this.array = t;
    }

    function c() {}

    var u,
        d,
        p = e.exports = {};
    !function () {
      try {
        u = "function" == typeof setTimeout ? setTimeout : r;
      } catch (e) {
        u = r;
      }

      try {
        d = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (e) {
        d = n;
      }
    }();
    var h,
        f = [],
        g = !1,
        y = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }
      f.push(new l(e, t)), 1 !== f.length || g || o(s);
    }, l.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = c, p.addListener = c, p.once = c, p.off = c, p.removeListener = c, p.removeAllListeners = c, p.emit = c, p.prependListener = c, p.prependOnceListener = c, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      var t = {},
          r = "";

      for (var o in e) {
        var a = e[o];
        if ("$unique" === o) t[i.IS_UNIQUE] = a;else if ("$nest" === o) {
          var s = a;

          for (var l in s) {
            var c = s[l];
            t[l] = n(c).result;
          }
        } else "$debugName" === o ? r = a : t[o] = a;
      }

      return {
        result: t,
        debugName: r
      };
    }

    function o(e) {
      var t = {
        $debugName: void 0,
        keyframes: {}
      };

      for (var r in e) {
        var n = e[r];
        "$debugName" === r ? t.$debugName = n : t.keyframes[r] = n;
      }

      return t;
    }

    t.a = n, t.b = o;
    var i = r(6);
    r.n(i);
  }, function (e, t) {}, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(2),
        o = r(3),
        i = o.TabStyles.Opacity,
        a = o.TabStyles.Typography,
        s = o.TabStyles.Colors,
        l = s.F2,
        c = s.F2_5,
        u = s.F7,
        d = s.F8,
        p = s.L5,
        h = s.L6,
        f = s.L7,
        g = s.L8,
        y = s.L9,
        b = s.GoLight,
        v = s.GoDark,
        m = s.AttentionDark,
        w = s.AttentionLight,
        _ = {
      backgroundColor: "transparent",
      borderRadius: 1,
      border: "1px solid transparent",
      boxSizing: "border-box",
      color: a.Color.Primary,
      fontFamily: a.FontFamily,
      fontSize: 12,
      fontWeight: "normal",
      height: 24,
      minWidth: 84,
      padding: "0 24px",
      whiteSpace: "nowrap",
      $nest: {
        "&:disabled": {
          color: "black",
          opacity: i.Disabled
        }
      }
    };
    t.ButtonClassNames = {
      primary: n.style(_, {
        backgroundColor: b,
        borderColor: b,
        color: "white",
        $nest: {
          "&:hover:enabled, &:focus": {
            borderColor: g
          },
          "&:active:enabled": {
            backgroundColor: v,
            borderColor: v
          },
          "&:disabled": {
            borderColor: f,
            backgroundColor: u
          }
        }
      }),
      destructive: n.style(_, {
        backgroundColor: w,
        borderColor: w,
        color: "white",
        $nest: {
          "&:hover:enabled, &:focus": {
            borderColor: g
          },
          "&:active:enabled": {
            backgroundColor: m,
            borderColor: m
          },
          "&:disabled": {
            borderColor: f,
            backgroundColor: u
          }
        }
      }),
      filled: n.style(_, {
        backgroundColor: p,
        borderColor: p,
        $nest: {
          "&:hover:enabled, &:focus": {
            borderColor: g
          },
          "&:active:enabled": {
            backgroundColor: d,
            borderColor: g,
            color: "white"
          },
          "&:disabled": {
            backgroundColor: u,
            borderColor: f
          }
        }
      }),
      outline: n.style(_, {
        borderColor: h,
        $nest: {
          "&:hover:enabled, &:focus": {
            borderColor: g
          },
          "&:active:enabled": {
            backgroundColor: l,
            borderColor: y
          },
          "&:disabled": {
            backgroundColor: "transparent",
            borderColor: y
          }
        }
      }),
      blackText: n.style(_, {
        fontWeight: "bold",
        $nest: {
          "&:hover:enabled, &:focus": {
            backgroundColor: l
          },
          "&:active:enabled": {
            backgroundColor: c,
            color: "black"
          }
        }
      })
    }, t.ButtonClassNames.filledGreen = t.ButtonClassNames.primary, t.ButtonClassNames.attentionRed = t.ButtonClassNames.destructive, Object.freeze(t.ButtonClassNames);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(0),
        o = r(1),
        i = r(8);
    t.Checkbox = o.forwardRef(function (e, t) {
      return o.createElement(i.Selector, n.__assign({}, e, {
        ref: t,
        type: "checkbox"
      }));
    }), t.Checkbox.displayName = "Checkbox";
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(1),
        i = r(2),
        a = r(3),
        s = r(9),
        l = r(22),
        c = a.TabStyles.Colors,
        u = a.TabStyles.Spacing,
        d = a.TabStyles.Typography,
        p = a.TabStyles.Sizing,
        h = p.BorderWidth,
        f = p.BorderRadius,
        g = p.RowHeight,
        y = c.GoLight,
        b = c.L3,
        v = c.L6,
        m = c.L8,
        w = c.L9,
        _ = i.style({
      background: "transparent no-repeat center right",
      border: "none",
      borderRadius: 0,
      color: d.Color.Primary,
      fontFamily: d.FontFamily,
      fontSize: d.Sizing.Default,
      height: "100%",
      outline: "none",
      width: "100%",
      "-moz-appearance": "none",
      "-webkit-appearance": "none",
      $nest: n.__assign({
        "&:disabled": {
          color: "black"
        }
      }, (s.isIE || s.isEdge) && {
        "&::-ms-expand": {
          $unique: !0,
          display: "none"
        },
        "&::-ms-value": {
          $unique: !0,
          background: "none",
          color: d.Color.Primary
        },
        "&:disabled::-ms-value": {
          $unique: !0,
          color: "black"
        },
        "&:focus": {
          outline: "1px solid " + y
        },
        "& > option": {
          color: "black"
        }
      })
    }),
        S = i.style({
      borderColor: v,
      boxSizing: "border-box",
      display: "inline-block",
      height: "0",
      minHeight: g,
      position: "relative",
      $nest: {
        "&:hover:not(.disabled)": {
          borderColor: m
        },
        "&:active:not(.disabled)": {
          borderColor: w
        },
        "&:focus-within": {
          $unique: !0,
          borderColor: y
        },
        "&.line": {
          borderBottomStyle: "solid",
          borderBottomWidth: h,
          $nest: {
            "& > select": {
              backgroundImage: "url('" + l.LineAndTextDropdownArrow.data(m) + "')",
              paddingRight: l.LineAndTextDropdownArrow.width
            },
            "&:active > select, &:hover > select": {
              backgroundImage: "url('" + l.LineAndTextDropdownArrow.data(w) + "')"
            }
          }
        },
        "&.text": {
          $nest: {
            "& > select": {
              backgroundImage: "url('" + l.LineAndTextDropdownArrow.data(m) + "')",
              paddingRight: l.LineAndTextDropdownArrow.width
            },
            "&:active > select, &:hover > select": {
              backgroundImage: "url('" + l.LineAndTextDropdownArrow.data(w) + "')"
            }
          }
        },
        "&.icon": {
          $nest: {
            "& > select": {
              backgroundImage: "url('" + l.IconDropdownArrow.data(m) + "')",
              paddingRight: l.IconDropdownArrow.width
            },
            "&:active > select, &:hover > select": {
              backgroundImage: "url('" + l.IconDropdownArrow.data(w) + "')"
            }
          }
        },
        "&.outline": {
          borderStyle: "solid",
          borderRadius: f,
          borderWidth: h,
          $nest: {
            "& > select": {
              backgroundImage: "url('" + l.OutlineDropdownArrow.data(m) + "')",
              paddingLeft: u.DefaultSpace,
              paddingRight: l.OutlineDropdownArrow.width + u.DefaultSpace
            },
            "&:active > select, &:hover > select": {
              backgroundImage: "url('" + l.OutlineDropdownArrow.data(w) + "')"
            },
            "&:after": {
              background: b,
              bottom: 0,
              content: "'\\200B'",
              pointerEvents: "none",
              position: "absolute",
              right: l.OutlineDropdownArrow.width,
              top: 0,
              width: 1
            }
          }
        },
        "&.disabled": {
          borderColor: w + " !important",
          color: "black !important",
          opacity: a.TabStyles.Opacity.Disabled
        }
      }
    });

    t.DropdownSelect = o.forwardRef(function (e, t) {
      var r = e.className,
          a = e.disabled,
          s = (e.multiple, e.kind),
          l = n.__rest(e, ["className", "disabled", "multiple", "kind"]);

      return o.createElement("div", {
        className: i.classes(S, s, r, a && "disabled")
      }, o.createElement("select", n.__assign({}, l, {
        className: _,
        disabled: a,
        ref: t
      })));
    });
    t.DropdownSelect.defaultProps = {
      kind: "outline"
    }, t.DropdownSelect.displayName = "DropdownSelect";
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(3),
        o = n.TabStyles.Colors.L8,
        i = function i(e) {
      return "data:image/svg+xml," + encodeURIComponent(e);
    };

    t.OutlineDropdownArrow = {
      width: 18,
      height: 18,
      data: function data(e) {
        return void 0 === e && (e = o), i('<svg xmlns="http://www.w3.org/2000/svg" width="' + t.OutlineDropdownArrow.width + '" height="' + t.OutlineDropdownArrow.height + '"><path fill="' + e + '" d="M5.8,7.3l3.5,4.6c0.1,0.1,0.2,0.1,0.3,0l3.6-4.6C13.3,7.1,13.2,7,13,7H6C5.8,7,5.7,7.1,5.8,7.3z"/></svg>');
      }
    }, t.LineAndTextDropdownArrow = {
      height: 20,
      width: 16,
      data: function data(e) {
        return void 0 === e && (e = o), i('<svg xmlns="http://www.w3.org/2000/svg" width="' + t.LineAndTextDropdownArrow.width + '" height="' + t.LineAndTextDropdownArrow.height + '"><path fill="' + e + '" d="M6.3,7h8.5C15,7,15.1,7.3,15,7.4l-4.2,5.3c-0.1,0.2-0.4,0.2-0.5,0L6,7.4C5.9,7.3,6,7,6.3,7z"/></svg>');
      }
    }, t.IconDropdownArrow = {
      height: 5,
      width: 7,
      data: function data(e) {
        return void 0 === e && (e = o), i('<svg xmlns="http://www.w3.org/2000/svg" width="' + t.IconDropdownArrow.width + '" height="' + t.IconDropdownArrow.height + '"><path fill="' + e + '" d="M5.8,1H1.2C1.1,1,1,1.1,1.1,1.2l2.3,2.7C3.4,4,3.6,4,3.6,3.9l2.3-2.7 C6,1.1,5.9,1,5.8,1z"/></svg>');
      }
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(1),
        i = r(2),
        a = r(3),
        s = r(10),
        l = r(11),
        c = a.TabStyles.Colors,
        u = c.L3,
        d = c.L6,
        p = c.L8,
        h = c.L9,
        f = c.L9Disabled,
        g = function g(e, t) {
      return void 0 === e && (e = p), "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="18" height="11"><path transform="' + (t ? "rotate(180) translate(-18 -11.5)" : "translate(0 -1)") + '" fill="' + e + '" d="M6 7.7L8.8 4c.1 0 .3 0 .3.1L12 7.7c0 .1 0 .3-.2.3H6.2C6 8 6 7.8 6 7.7z"/></svg>') + "')";
    },
        y = i.style({
      display: "inline-block",
      position: "relative"
    }),
        b = i.style({
      border: "1px solid " + d,
      borderRadius: 1,
      boxSizing: "border-box",
      height: a.TabStyles.Sizing.RowHeight,
      outline: "none",
      padding: 0,
      paddingLeft: 6,
      paddingRight: 18,
      width: "100%",
      $nest: {
        "&::-ms-clear": {
          $unique: !0,
          display: "none"
        },
        ":hover > &:enabled, &:focus": {
          borderColor: p
        },
        "&:disabled": {
          color: "black",
          borderColor: h,
          opacity: .35
        }
      }
    }),
        v = i.style({
      background: u,
      boxSizing: "border-box",
      display: "inline-flex",
      flexDirection: "column",
      paddingLeft: 1,
      position: "absolute",
      width: 17,
      bottom: 1,
      right: 1,
      top: 1
    }),
        m = i.style({
      background: "white " + g(p) + " no-repeat",
      backgroundPositionX: "center",
      boxSizing: "border-box",
      border: "none",
      height: "calc(50% - 0.5px)",
      width: "100%",
      padding: 0,
      $nest: {
        "&:enabled:hover": {
          backgroundImage: g(h)
        },
        "&:disabled": {
          backgroundImage: g(f)
        },
        "button + &": {
          backgroundImage: g(p, !0),
          marginTop: 1
        },
        "button + &:enabled:hover": {
          backgroundImage: g(h, !0)
        },
        "button + &:disabled": {
          backgroundImage: g(f, !0)
        }
      }
    }),
        w = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.state = {
          inputText: String(t.props.value)
        }, t.handleButtonsFocus = function () {
          t.inputElement.focus();
        }, t.handleInputBlur = function () {
          t.triggerChange();
        }, t.handleInputChange = function (e) {
          var r = e.target.value;

          if ((t.props.floatingPoint ? /^[-+]?[0-9]*\.?[0-9]*$/ : /^[-+]?[0-9]*$/).test(r)) {
            var n = parseFloat(r);
            n.toString() !== r ? t.setState({
              inputText: r
            }) : t.triggerChange(n);
          }
        }, t.handleKeyDown = function (e) {
          if (!(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)) {
            switch (e.key) {
              case "ArrowUp":
                t.stepUp();
                break;

              case "ArrowDown":
                t.stepDown();
                break;

              case "Home":
                isFinite(t.props.min) && t.triggerChange(t.props.min);
                break;

              case "End":
                isFinite(t.props.max) && t.triggerChange(t.props.max);
                break;

              case "Enter":
                t.triggerChange();
                break;

              case "Escape":
                t.revert();
                break;

              case "PageUp":
                t.pageUp();
                break;

              case "PageDown":
                t.pageDown();
                break;

              default:
                return;
            }

            e.preventDefault(), e.stopPropagation();
          }
        }, t.handleDivRef = function (e) {
          t.inputElement = e ? e.querySelector("input") : null;
        }, t.pageDown = function () {
          t.stepDown(t.props.step * t.props.pageSteps);
        }, t.pageUp = function () {
          t.stepUp(t.props.step * t.props.pageSteps);
        }, t.stepDown = function (e) {
          void 0 === e && (e = t.props.step), t.triggerChange(l.snapUp(t.props.value, e) - e);
        }, t.stepUp = function (e) {
          void 0 === e && (e = t.props.step), t.triggerChange(l.snapDown(t.props.value, e) + e);
        }, t;
      }

      return n.__extends(t, e), t.prototype.componentDidUpdate = function (e) {
        e.value === this.props.value || isNaN(this.props.value) || this.setState({
          inputText: String(this.props.value)
        });
      }, t.prototype.revert = function () {
        this.triggerChange(this.props.value);
      }, t.prototype.triggerChange = function (e) {
        var t = this;
        void 0 === e && (e = parseFloat(this.inputElement.value)), this.props.floatingPoint || (e = l.truncate(e));
        var r = l.clamp(isNaN(e) ? this.props.value : e, this.props.min, this.props.max);
        this.setState({
          inputText: String(r)
        }, function () {
          r !== t.props.value && t.props.onValueChange && t.props.onValueChange(r);
        });
      }, t.prototype.render = function () {
        var e = this.props,
            t = e.className,
            r = e.disabled,
            a = (e.floatingPoint, e.inputRef),
            l = e.min,
            c = e.max,
            u = (e.onValueChange, e.pageSteps, e.step, e.value),
            d = n.__rest(e, ["className", "disabled", "floatingPoint", "inputRef", "min", "max", "onValueChange", "pageSteps", "step", "value"]);

        return o.createElement("div", n.__assign({}, d, {
          className: i.classes(t, y),
          ref: this.handleDivRef
        }), o.createElement("input", {
          "aria-valuemin": s.conditional(isFinite(l), l),
          "aria-valuemax": s.conditional(isFinite(c), c),
          "aria-valuenow": this.state.inputText,
          className: b,
          disabled: r,
          onBlur: this.handleInputBlur,
          onChange: this.handleInputChange,
          onKeyDown: this.handleKeyDown,
          ref: a,
          role: "spinbutton",
          type: "text",
          value: this.state.inputText
        }), o.createElement("div", {
          className: v,
          onFocus: this.handleButtonsFocus,
          tabIndex: -1
        }, this.renderButton({
          downButton: !1,
          disabled: r,
          min: l,
          max: c,
          value: u
        }), this.renderButton({
          downButton: !0,
          disabled: r,
          min: l,
          max: c,
          value: u
        })));
      }, t.prototype.renderButton = function (e) {
        var t = this,
            r = e.disabled || isNaN(e.value) || (e.downButton ? e.value <= e.min : e.value >= e.max);
        return o.createElement("button", {
          "aria-hidden": !0,
          className: m,
          disabled: r,
          onClick: function onClick() {
            return e.downButton ? t.stepDown() : t.stepUp();
          },
          tabIndex: -1
        });
      }, t.defaultProps = {
        min: -1 / 0,
        max: 1 / 0,
        pageSteps: 10,
        step: 1
      }, t;
    }(o.Component);

    t.Stepper = w;
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      return {
        normal: {
          backgroundColor: e,
          color: w
        },
        dark: {
          backgroundColor: t,
          color: w
        },
        light: {
          backgroundColor: c.rgb2rgba(e, .55),
          borderColor: "transparent",
          color: u.Color.Primary
        }
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = r(0),
        i = r(1),
        a = r(2),
        s = r(5),
        l = r(3),
        c = r(25),
        u = l.TabStyles.Typography,
        d = l.TabStyles.Colors,
        p = d.ApplicationBlue,
        h = d.AttentionLight,
        f = d.AttentionDark,
        g = d.Continuous,
        y = d.ContinuousDark,
        b = d.Discrete,
        v = d.DiscreteDark,
        m = d.F5,
        w = "rgba(255, 255, 255, 0.9)",
        _ = {
      backgroundColor: "transparent",
      color: u.Color.Primary
    },
        S = {
      continuous: n(g, y),
      discrete: n(b, v),
      invalid: n(h, f),
      other: n(m, "rgb(84, 84, 84)")
    },
        C = a.style(s.PreventUserSelect, {
      alignItems: "center",
      borderColor: "transparent",
      borderRadius: 10,
      borderStyle: "solid",
      borderWidth: 1,
      boxSizing: "border-box",
      display: "flex",
      fontFamily: u.FontFamily,
      fontSize: u.Sizing.Default,
      height: 20,
      minWidth: 150,
      overflowY: "hidden",
      padding: "0 10px",
      $nest: {
        "&:not(.schema)": {
          $nest: {
            "&.continuous": S.continuous.normal,
            "&.discrete": S.discrete.normal,
            "&.invalid": S.invalid.normal,
            "&.other": o.__assign({}, S.other.normal, {
              color: u.Color.Primary
            }),
            "&:hover": {
              borderColor: p
            },
            "&.continuous.selected": S.continuous.dark,
            "&.discrete.selected": S.discrete.dark,
            "&.invalid.selected": S.invalid.dark,
            "&.other.selected": S.other.dark
          }
        },
        "&.schema": o.__assign({}, _, {
          $nest: {
            "&.continuous:hover": S.continuous.light,
            "&.discrete:hover": S.discrete.light,
            "&.invalid:hover": S.invalid.light,
            "&.other:hover": S.other.light,
            "&.continuous.selected": S.continuous.normal,
            "&.discrete.selected": S.discrete.normal,
            "&.invalid.selected": S.invalid.normal,
            "&.other.selected": o.__assign({}, S.other.normal, {
              color: u.Color.Primary
            })
          }
        })
      }
    });
    t.Pill = i.forwardRef(function (e, t) {
      var r = e.className,
          n = e.kind,
          s = e.schema,
          l = e.selected,
          c = o.__rest(e, ["className", "kind", "schema", "selected"]);

      return i.createElement("div", o.__assign({}, c, {
        className: a.classes(C, s && "schema", l && "selected", n, r),
        ref: t
      }));
    }), t.Pill.displayName = "Pill";
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      return void 0 === t && (t = 1), e.replace(/rgb\(([^\)]*)\)/, "rgba($1, " + t + ")");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.rgb2rgba = n;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(0),
        o = r(1),
        i = r(8);
    t.Radio = o.forwardRef(function (e, t) {
      return o.createElement(i.Selector, n.__assign({}, e, {
        ref: t,
        type: "radio"
      }));
    }), t.Radio.displayName = "Radio";
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(1),
        i = r(2),
        a = r(28),
        s = function s(e) {
      return "data:image/svg+xml," + encodeURIComponent(a.SpinnerSvg(e));
    };

    t.DarkColor = "rgb(97, 101, 112)", t.LightColor = "rgba(255, 255, 255, 0.8)";
    var l = {
      background: "rgba(255,255,255,.6)",
      borderRadius: "15%",
      boxSizing: "border-box",
      display: "inline-flex",
      lineHeight: "normal"
    },
        c = i.style(l),
        u = {
      "100%": {
        transform: "rotate(360deg)"
      }
    },
        d = i.keyframes(u);
    i.cssRule("@-webkit-keyframes " + d, u);

    var p = {
      animation: d + " 1s linear infinite",
      WebkitAnimation: d + " 1s linear infinite",
      cursor: "wait",
      margin: "auto",
      overflow: "hidden"
    },
        h = i.style(p),
        f = function f(e) {
      return {
        height: 1.3 * e,
        width: 1.3 * e
      };
    };

    t.Spinner = o.forwardRef(function (e, r) {
      var a = n.__assign({}, e.style, e.showUnderlay ? f(e.dimension) : void 0);

      return o.createElement("div", {
        className: i.classes(e.className, e.showUnderlay && c),
        id: e.id,
        ref: r,
        style: a
      }, o.createElement("img", {
        className: h,
        src: s("dark" === e.color ? t.DarkColor : t.LightColor),
        style: {
          height: e.dimension,
          width: e.dimension
        }
      }));
    }), t.Spinner.defaultProps = {
      color: "dark",
      dimension: 50,
      showUnderlay: !1
    }, t.Spinner.displayName = "Spinner";
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.SpinnerSvg = function (e) {
      return '\n<svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">\n  <style>\n    #tail { fill: url(#fade) }\n    #head { fill: ' + e + " }\n    stop { stop-color: " + e + ' }\n  </style>\n  <linearGradient id="fade" x2="50" y1="25" y2="25" gradientUnits="userSpaceOnUse">\n    <stop offset="0" stop-opacity="0"/>\n    <stop offset=".15" stop-opacity=".04"/>\n    <stop offset=".3" stop-opacity=".16"/>\n    <stop offset=".45" stop-opacity=".36"/>\n    <stop offset=".61" stop-opacity=".64"/>\n    <stop offset=".76"/>\n  </linearGradient>\n  <path id="head" d="M0 25a25 25 0 1 0 50 0h-3.9a21.1 21.1 0 1 1-42.2 0" />\n  <path id="tail" d="M50 25a25 25 0 0 0-50 0h3.9a21.1 21.1 0 1 1 42.2 0" />\n</svg>';
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(1),
        i = r(4),
        a = r(11),
        s = r(30),
        l = r(12),
        c = function c(e, t) {
      var r = i.closest(e, '[role="tab"][data-tab-index]');
      return r ? parseInt(r.getAttribute("data-tab-index"), 10) : t;
    },
        u = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.id = i.generateId(), t.tabListElement = o.createRef(), t.state = {
          focusedIndex: -1
        }, t.handleBlur = function (e) {
          t.tabListElement.current.contains(e.relatedTarget) || t.setFocusedIndex(-1);
        }, t.handleClick = function (e) {
          t.triggerTabChange(c(e.target, t.props.selectedTabIndex));
        }, t.handleKeyDown = function (e) {
          var r = c(e.target, NaN);

          if (!isNaN(r)) {
            var n = t.getNextTabIndexFromKey(r, e.key);

            if (!(n < 0)) {
              var o = "automatic" === t.props.activation || r === n,
                  i = o ? function () {
                return t.triggerTabChange(n);
              } : void 0;
              r !== n && e.preventDefault(), e.stopPropagation(), t.setFocusedIndex(n, i);
            }
          }
        }, t.handleFocus = function (e) {
          t.setFocusedIndex(c(e.target, t.state.focusedIndex));
        }, t.setFocusedIndex = function (e, r) {
          void 0 === r && (r = function r() {
            return null;
          }), t.state.focusedIndex === e ? r() : t.setState({
            focusedIndex: e
          }, r);
        }, t;
      }

      return n.__extends(t, e), t.prototype.triggerTabChange = function (e) {
        this.props.onTabChange && e !== this.props.selectedTabIndex && this.props.onTabChange(e);
      }, t.prototype.getNextTabIndexFromKey = function (e, t) {
        var r = this.props.tabs.length;

        switch (t) {
          case "ArrowRight":
            return (e + 1) % r;

          case "ArrowLeft":
            return (r + e - 1) % r;

          case "Home":
            return 0;

          case "End":
            return r - 1;

          case "Enter":
          case " ":
            return e;

          default:
            return -1;
        }
      }, t.prototype.buildTabId = function (e) {
        return this.id + "-tab" + (e + 1);
      }, t.prototype.buildTabPanelId = function (e) {
        return this.id + "-tabpanel" + (e + 1);
      }, t.prototype.renderTabList = function (e, t, r) {
        var n = this,
            i = 100 / t.length,
            a = t.map(function (t, a) {
          return o.createElement(s.Tab, {
            "aria-controls": n.buildTabPanelId(a),
            children: t.content,
            id: n.buildTabId(a),
            index: a,
            isFocused: a === n.state.focusedIndex,
            isSelected: a === e,
            flexPercent: void 0 === r || "justified" === r ? i : void 0,
            key: a,
            title: t.title
          });
        });
        return o.createElement("div", {
          className: l.TabListClassName,
          children: a,
          onBlur: this.handleBlur,
          onClick: this.handleClick,
          onFocus: this.handleFocus,
          onKeyDown: this.handleKeyDown,
          ref: this.tabListElement,
          role: "tablist"
        });
      }, t.prototype.renderTabPanel = function (e, t) {
        return o.createElement("div", {
          "aria-labelledby": this.buildTabId(e),
          className: l.TabPanelOuterContainerClassName,
          id: this.buildTabPanelId(e),
          role: "tabpanel"
        }, t);
      }, t.prototype.render = function () {
        var e = this.props,
            t = (e.activation, e.alignment),
            r = e.children,
            i = (e.onTabChange, e.selectedTabIndex),
            s = e.tabs,
            l = n.__rest(e, ["activation", "alignment", "children", "onTabChange", "selectedTabIndex", "tabs"]),
            c = a.clamp(i, 0, s.length - 1);

        return o.createElement("div", n.__assign({}, l), this.renderTabList(c, s, t), this.renderTabPanel(c, r));
      }, t.defaultProps = {
        activation: "automatic",
        alignment: "justified",
        selectedTabIndex: 0,
        tabs: []
      }, t;
    }(o.PureComponent);

    t.Tabs = u;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(1),
        i = r(10),
        a = r(4),
        s = r(12),
        l = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.tabButtonRef = o.createRef(), t.contentRef = o.createRef(), t.state = {}, t.handleMouseEnter = function () {
          var e = t.contentRef && a.isElementOverflownX(t.contentRef.current) ? t.contentRef.current.textContent : void 0;
          e !== t.state.title && t.setState({
            title: e
          });
        }, t;
      }

      return n.__extends(t, e), t.prototype.componentDidUpdate = function (e) {
        var t = this.tabButtonRef.current;
        this.props.isFocused && !e.isFocused && document.documentElement.contains(t) && t.focus();
      }, t.prototype.render = function () {
        var e = {
          "aria-controls": this.props["aria-controls"],
          "aria-selected": this.props.isSelected,
          className: s.TabButtonClassName,
          "data-tab-index": this.props.index,
          id: this.props.id,
          onMouseEnter: this.handleMouseEnter,
          ref: this.tabButtonRef,
          role: "tab",
          tabIndex: this.props.isSelected || this.props.isFocused ? 0 : -1,
          title: this.props.title || this.state.title
        },
            t = n.__assign({}, i.conditional(!!this.props.flexPercent, {
          flex: "1 0 " + this.props.flexPercent + "%"
        }));

        return o.createElement("button", n.__assign({}, e, {
          style: t
        }), o.createElement("div", {
          className: s.TabContentContainerClassName
        }, o.createElement("div", {
          className: s.TabContentClassName,
          ref: this.contentRef
        }, this.props.children)), o.createElement("div", {
          className: s.TabIndicatorClassName
        }));
      }, t;
    }(o.PureComponent);

    t.Tab = l;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.TextEllipsis = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n,
        o = r(0),
        i = r(1),
        a = r(2),
        s = r(3),
        l = r(9),
        c = r(4),
        u = r(33),
        d = s.TabStyles.Opacity,
        p = s.TabStyles.Typography,
        h = s.TabStyles.Colors,
        f = h.L6,
        g = h.L8,
        y = h.L9,
        b = h.AttentionLight,
        v = h.GoLight,
        m = function m(e) {
      return void 0 === e && (e = g), "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path fill="' + e + '" d="M7.5 0C5.015 0 3 2.015 3 4.5S5.015 9 7.5 9 12 6.985 12 4.5 9.985 0 7.5 0zm0 8C5.567 8 4 6.433 4 4.5S5.567 1 7.5 1 11 2.567 11 4.5 9.433 8 7.5 8z"/><path fill="' + e + '" d="M5.026 7.858l-3.96 3.96c-.243.243-.641.243-.884 0s-.243-.641 0-.884l3.96-3.96c.243-.243.641-.243.884 0s.243.641 0 .884z"/></svg>') + "')";
    };

    t.RootClassName = a.style({
      color: p.Color.Secondary,
      display: "inline-flex",
      flexDirection: "column",
      fontFamily: p.FontFamily,
      position: "relative",
      $nest: {
        "> .errorMessage": {
          color: b,
          fontSize: p.Sizing.Tiny,
          lineHeight: p.Sizing.Tiny + "px",
          marginTop: s.TabStyles.Spacing.SmallSpace,
          order: 2
        },
        "> .errorMessage:after": {
          content: "'\\200B'"
        }
      }
    });
    var w = l.isIE ? "-ms-input-placeholder" : ":placeholder";
    t.InputClassName = a.style({
      border: "0 solid " + f,
      boxSizing: "border-box",
      color: p.Color.Primary,
      fontSize: p.Sizing.Default,
      height: s.TabStyles.Sizing.RowHeight,
      paddingRight: s.TabStyles.Sizing.RowHeight,
      order: 1,
      outline: "none",
      "-webkit-appearance": "none",
      $nest: (n = {}, n["&:" + w] = {
        $unique: !0,
        color: p.Color.Secondary
      }, n["&::-ms-clear"] = {
        $unique: !0,
        display: "none"
      }, n["&:hover"] = {
        borderColor: g
      }, n["&:active, &&:focus"] = {
        borderColor: v
      }, n['&&[aria-invalid="true"]'] = {
        borderColor: b
      }, n["&&:disabled"] = {
        color: "black",
        borderColor: y,
        opacity: d.Disabled
      }, n[".outline > &, .search > &"] = {
        borderWidth: 1,
        borderRadius: 1,
        paddingLeft: s.TabStyles.Spacing.DefaultSpace
      }, n[".line > &"] = {
        borderBottomWidth: 1,
        borderRadius: 0
      }, n[".line > &[data-haslabel]:focus:" + w] = {
        $unique: !0,
        opacity: 0
      }, n[".search > &:focus"] = {
        borderColor: g
      }, n['.search > &[value=""]'] = {
        background: "calc(100% - 6px) center no-repeat " + m(),
        $nest: {
          "&:hover": {
            backgroundImage: m(y)
          }
        }
      }, n)
    });

    var _ = a.style({
      display: "block",
      fontSize: p.Sizing.Tiny,
      lineHeight: p.Sizing.Tiny + "px",
      order: 0,
      $nest: {
        ":not([data-haslabel]) + &": {
          display: "none"
        },
        "&:not(:empty)": {
          marginBottom: s.TabStyles.Spacing.SmallSpace
        },
        '.line > input[value=""] + &': {
          opacity: 0
        },
        ".line > input:focus + &": {
          opacity: 1
        }
      }
    });

    t.TextField = i.forwardRef(function (e, r) {
      var n = c.generateId(),
          s = e.className,
          l = e.errorMessage,
          d = e.id,
          p = e.label,
          h = e.onClear,
          f = e.style,
          g = e.kind,
          y = o.__rest(e, ["className", "errorMessage", "id", "label", "onClear", "style", "kind"]);

      y.placeholder = y.placeholder || p, y["aria-errormessage"] = y["aria-errormessage"] || c.generateId(), y["aria-invalid"] = !!l;

      var b = !!e.value && !!h,
          v = function v(e) {
        b && "Escape" === e.key && (e.preventDefault(), e.stopPropagation(), e.repeat || h());
      },
          m = function m(e) {
        e.currentTarget.parentElement.firstChild.focus();
      };

      return i.createElement("div", {
        className: a.classes(s, t.RootClassName, g),
        onKeyDown: v,
        id: d,
        style: f
      }, i.createElement("input", o.__assign({}, y, {
        className: t.InputClassName,
        "data-haslabel": !!p || void 0,
        id: n,
        ref: r
      })), i.createElement("label", {
        htmlFor: n,
        className: _
      }, p), i.createElement("div", {
        "aria-live": "polite",
        className: "errorMessage",
        id: y["aria-errormessage"]
      }, l), b && i.createElement(u.TextFieldClearButton, {
        onClick: e.onClear,
        onFocus: m
      }));
    });
    t.TextField.defaultProps = {
      kind: "outline",
      type: "text"
    }, t.TextField.displayName = "TextField";
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = r(0),
        o = r(1),
        i = r(2),
        a = r(3),
        s = a.TabStyles.Colors,
        l = s.L8,
        c = s.L9,
        u = function u(e) {
      return void 0 === e && (e = l), "url('data:image/svg+xml," + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12"><path fill="' + e + '" d="M8.9 2.9L3 8.9c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8l5.9-5.9c.2-.2.6-.2.8 0 .2.2.2.5 0 .7z"/><path fill="' + e + '" d="M3 2.2l5.9 5.9c.2.2.2.6 0 .8-.2.2-.6.2-.8 0L2.2 3c-.2-.2-.2-.6 0-.8.3-.2.6-.2.8 0z"/></svg>') + "')";
    },
        d = i.style({
      display: "none",
      position: "absolute",
      top: 0,
      right: 0,
      width: a.TabStyles.Sizing.RowHeight,
      height: a.TabStyles.Sizing.RowHeight,
      alignItems: "center",
      justifyContent: "center",
      $nest: {
        "input:focus ~ &, input:hover ~ &, &:hover, &:active": {
          display: "inline-flex"
        },
        "label:not(:empty) ~ &": {
          top: a.TabStyles.Typography.Sizing.Tiny + a.TabStyles.Spacing.SmallSpace
        },
        "&:before": {
          content: u(l),
          marginTop: 1
        },
        "&:hover:before": {
          content: u(c)
        }
      }
    });

    t.TextFieldClearButton = function (e) {
      return o.createElement("div", n.__assign({}, e, {
        className: i.classes("clearButton", d),
        tabIndex: -1
      }));
    }, t.TextFieldClearButton.displayName = "TextFieldClearButton";
  }]);
});